import { render, staticRenderFns } from "./franchisee-join.vue?vue&type=template&id=02438825&scoped=true&"
import script from "./franchisee-join.vue?vue&type=script&lang=js&"
export * from "./franchisee-join.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-join.vue?vue&type=style&index=0&id=02438825&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02438825",
  null
  
)

export default component.exports